import { render, staticRenderFns } from "./pageb.vue?vue&type=template&id=69abaf60&scoped=true"
import script from "./pageb.vue?vue&type=script&lang=js"
export * from "./pageb.vue?vue&type=script&lang=js"
import style0 from "./pageb.vue?vue&type=style&index=0&id=69abaf60&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "69abaf60",
  null
  
)

export default component.exports